import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

// Define the base endpoint for cultivation
const CULTIVATION_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.CULTIVATION,
  false // No tenant ID in the base URL
);

export const cultivationApi = {
  getCultivationForm: (farmId, edit) =>
    apiClient.get(`${CULTIVATION_BASE}/form?is_edit=${edit}&farm_id=${farmId}`),

  getEditCultivationForm: (id, edit, cultivationId, view) =>
    apiClient.get(
      `${CULTIVATION_BASE}/form?is_edit=${edit}&farm_id=${id}&cultivation_id=${cultivationId}&is_view=${view}`
    ),

  populateCultivationEditForm: cultivationId =>
    apiClient.get(`${CULTIVATION_BASE}/${cultivationId}`),

  submitCultivation: (data, farmId) =>
    apiClient.post(`${CULTIVATION_BASE}/${farmId}`, data),

  updateCultivationReport: (cultivationId, data) =>
    apiClient.put(`${CULTIVATION_BASE}/${cultivationId}`, data),

  getHarvestForm: (cultivationId, edit) =>
    apiClient.get(
      `${CULTIVATION_BASE}/harvest/${cultivationId}/form?is_edit=${edit}`
    ),

  updateHarvestForm: (cultivationId, data) =>
    apiClient.put(`${CULTIVATION_BASE}/harvest/${cultivationId}`, data)
};
